import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import ConfirmEmailRequiredPage from "../pages/02_user/ConfirmEmailRequiredPage.tsx";
import { canUseFullApp } from "../utils/authAccess";

export default function EmailConfirmedRoute() {
    const {
        isAuthenticated,
        isLoading,
        emailConfirmed,
        isSocialAccount,
        socialProviders,
    } = useContext(AuthContext);

    // ждём, пока AuthProvider определит состояние
    if (isLoading) return null;

    // если не залогинен — этим занимается ProtectedRoute,
    if (!isAuthenticated) return <Outlet />;

    const hasFullAccess = canUseFullApp({
        emailConfirmed,
        isSocialAccount,
        socialProviders,
    });

    if (!hasFullAccess) {
        return <ConfirmEmailRequiredPage />;
    }

    return <Outlet />;
}
